import { localStorageStore } from "react-admin";

/** Persists locale, theme, and table preferences for the admin panel. */
export const adminStore = localStorageStore(undefined, "uqx-admin");
